// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { AppEnv } from './app-env';
import { TreatmentScanType } from 'app/core/enums';
import { SampleOrderDesignSimulation } from './sample-order-design-simulation.model';

const sampleOrderDesignSimulation: SampleOrderDesignSimulation = {
  enabled: true,
  message: 'Your files are ready for approval.',
  mockDesigner: {
    userId: 'auth0|68ad82f4e6d9335b482fa0b7',
    name: 'Elias Designer',
  },
  designFiles: [
    {
      scanType: TreatmentScanType.UpperJaw,
      fileGuid: 'd7a70348-4713-445a-bff1-b2ba4abff615',
      filename: 'patients/d7a70348-4713-445a-bff1-b2ba4abff615.stl',
      fileSize: 21512384,
      fileType: '.stl',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.LowerJaw,
      fileGuid: '5288381c-161b-4edb-b7ad-07bab13d2eb5',
      filename: 'patients/5288381c-161b-4edb-b7ad-07bab13d2eb5.stl',
      fileSize: 18352584,
      fileType: '.stl',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '8509e45a-a736-48f2-85fa-35f8dae55bc2',
      filename: 'patients/8509e45a-a736-48f2-85fa-35f8dae55bc2.stl',
      fileSize: 1552684,
      fileType: '.stl',
      teeth: '13',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '1758b444-548b-46ee-bd98-e3302162528b',
      filename: 'patients/1758b444-548b-46ee-bd98-e3302162528b.stl',
      fileSize: 1063984,
      fileType: '.stl',
      teeth: '12',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '568028d4-33ba-42c5-be77-0cec4d917a5b',
      filename: 'patients/568028d4-33ba-42c5-be77-0cec4d917a5b.stl',
      fileSize: 1114984,
      fileType: '.stl',
      teeth: '11',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '7f9c5baa-4655-4a0a-9d04-4149b1e71770',
      filename: 'patients/7f9c5baa-4655-4a0a-9d04-4149b1e71770.stl',
      fileSize: 869434,
      fileType: '.stl',
      teeth: '10',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: 'e13035c8-b897-42dc-838b-be3c6849a043',
      filename: 'patients/e13035c8-b897-42dc-838b-be3c6849a043.stl',
      fileSize: 1403084,
      fileType: '.stl',
      teeth: '8',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '06554f24-cc9f-48c7-9c55-685279533e3c',
      filename: 'patients/06554f24-cc9f-48c7-9c55-685279533e3c.stl',
      fileSize: 802884,
      fileType: '.stl',
      teeth: '9',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '78c166c1-026f-43e5-b7da-99c73adb6c00',
      filename: 'patients/78c166c1-026f-43e5-b7da-99c73adb6c00.stl',
      fileSize: 1381834,
      fileType: '.stl',
      teeth: '7',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: '274ce109-08ad-45e3-a011-bd486ae38d16',
      filename: 'patients/274ce109-08ad-45e3-a011-bd486ae38d16.stl',
      fileSize: 928234,
      fileType: '.stl',
      teeth: '6',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: 'e6fb2d4a-b4be-44af-9f39-54f0d916dca2',
      filename: 'patients/e6fb2d4a-b4be-44af-9f39-54f0d916dca2.stl',
      fileSize: 1279934,
      fileType: '.stl',
      teeth: '5',
      subGroup: '',
    },
    {
      scanType: TreatmentScanType.VeneersStl,
      fileGuid: 'd8e45699-ad1b-4036-9448-1a0339eae6a7',
      filename: 'patients/d8e45699-ad1b-4036-9448-1a0339eae6a7.stl',
      fileSize: 848584,
      fileType: '.stl',
      teeth: '4',
      subGroup: '',
    },
  ],
};

export const environment = {
  production: false,
  apiBaseUrl: 'https://api-staging.getneer.com/api/',
  // apiBaseUrl: 'http://localhost:5000/api/', // If you want to develop in local env but using staging remote DB
  apiSprintRayBaseUrl: 'https://staging-neer.sprintray.com/api/v2/',
  appBaseUrl: 'https://dashboard-staging.getneer.com/',
  appAccounts: 'https://staging.account.sprintray.com',
  appEnv: AppEnv.staging,
  sprintRayChatLink: 'https://staging-chat.sprintray.com',

  appSyncRegion: 'us-west-2',
  appSyncGraphQLEndpoint: 'https://5ljfevtirngt7oynmpjhmeqbzy.appsync-api.us-west-2.amazonaws.com/graphql',

  printPreviewBucketUrl: 'https://s3-us-west-1.amazonaws.com/print-preview-image',
  platformScreenshotBucketUrl: 'https://sprint-ray-files-staging.s3.us-west-2.amazonaws.com/delta',
  axionTrainingLink: 'https://sprintray.axiomtrainingcloud.com/',
  store: 'https://staging.store.ecomm.sprintray.com/',
  storePrint: 'https://staging.store.ecomm.sprintray.com/shop/product-category?cat=114&tag=',
  sprintrayCommunity: 'https://community.sprintray.com/',
  sprintray3DViewerUrl: 'https://3dviewer.staging.designservice.sprintray.com?t=1723457975',
  cloudDriveUrl: 'https://dev.designservice.sprintray.com/cloud-drive/embed?connection=neer',
  neerPrivacyUrl: 'https://www.getneer.com/pages/privacy-and-terms',

  stripe: {
    // paymentMethodConfigurationId: 'pmc_1QyS2OAWMILZMZN7SVJMNs2O', // TODO: Sprintray's
    paymentMethodConfigurationId: 'pmc_1Rxa2IJwfMrvM8XcZzuJqp2o',
    buyButtonId: 'buy_btn_1SugNEJwfMrvM8Xct3zjcflC',
    //TODO: Update from dashboard stripe
    moment5PackPriceId: 'price_1SufVUJwfMrvM8Xcwkndjf8x',
  },

  launchDarkly: {
    clientKey: '69afa79d7def3409eb6a77a8',
  },

  auth0: {
    clientID: 'pGy9tWlibcJ9ctxKA6JDR0Dpeh5sTxb7',
    domain: 'staging-auth.getneer.com',
    audience: 'https://staging-getneer.us.auth0.com/api/v2/',
    scope: 'openid email profile',
    responseType: 'token id_token',
  },
  googleMap: {
    apiKey: 'AIzaSyAF4ZK1WB8Qgx6tn6vq9o47QUpzWip7beM',
    mapId: 'f316a13183a1590f3e69ec41',
    apiUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
  },

  _3shape: {
    clientID: 'Sprintray.Staging',
    domain: 'staging-identity.3shape.com',
    scope: 'openid api offline_access communicate.connections.manage data.companies.read_only data.users.read_only',
    responseType: 'code',
    authorizePath: 'connect/authorize',
  },

  medit: {
    clientID: '5YfJHOwHUYhhB0cv1Qx5SdZ7nSH4hpyd',
    domain: 'stage-openapi-developers.meditlink.com',
    scope: 'USER GROUP CASE FILE',
    responseType: 'code',
    authorizePath: 'oauth/authorize',
  },

  itero: {
    clientID: 'Gr6l0KfTxiiSiqLvTNNjdu_8WBka',
    domain: 'identity-cus.dev.aligntech.com',
    scope: 'openid',
    responseType: 'code',
    authorizePath: 'oauth2/authorize',
  },

  cloudDriveExternalProviders: {
    medit: {
      clientId: 'EQprqaLzEvJyCgGb8C5UFeb1rngQl9eS',
      name: 'Medit',
    },
    _3shape: {
      clientId: 'QaD1Sq7aLNjxwptBcNPZyJ7FeoPuvbiq',
      name: '3Shape',
    },
    _3shapeDesktop: {
      clientId: '25hIavOQN4mtETT3XFJ2bb35KBdwiSPO',
      name: '3Shape Desktop',
    },
    dexis: {
      clientId: 'qN1TKtV08LhmPMuNIMQfLKQRnGay1Lmf',
      name: 'Dexis',
    },
    exocad: {
      clientId: 'zjHx8jfw0EUbXYZAwj7jGBHmo9mlvYhi',
      name: 'Exocad',
      disabled: false,
    },
    envista: {
      clientId: 'lIYynnnK3a6J4oNUluWiL10R2keZqjcC',
      name: 'Envista',
    },
    Itero: {
      clientId: 'N/A',
      name: 'iTero',
    },
  },

  organizationIds: {
    aspen: 'c7623ead-5d22-4413-aea7-2d0674727bd4',
    pacific: '21b18776-4b53-4613-9c40-55ab350ba3b7',
    pds: '95e556d8-d2fc-4ae0-bcc8-e9ac4edc5370',
    neer: '5097037e-c102-4325-ac9f-b6bded20ce5a',
  },
  aicad: {
    url: 'https://ai-cad.staging.designservice.sprintray.com/index.html#/',
    apiBaseUrl: 'https://flbb81b96d.execute-api.us-west-2.amazonaws.com/staging',
  },
  studio: {
    url: 'https://ai-cad.staging.designservice.sprintray.com/studio/index.html',
  },
  connections: {
    sprintRay: {
      auth0Connection: 'SprintRayDev',
    },
  },
  sampleOrderDefaults: {
    treatmentType: 'Neer',
    upperJawScanFile: {
      fileGuid: 'a2fe0031-bc9c-4a5b-95f7-dc6c692287ad',
      filename: 'patients/a2fe0031-bc9c-4a5b-95f7-dc6c692287ad.ply',
      fileSize: 12802484,
      fileType: 'ply',
      subGroup: '',
    },
    lowerJawScanFile: {
      fileGuid: 'dfa148a7-9ed0-4fef-b189-96af5ece7497',
      filename: 'patients/dfa148a7-9ed0-4fef-b189-96af5ece7497.ply',
      fileSize: 9665551,
      fileType: 'ply',
      subGroup: '',
    },
    biteScanFile: {
      fileGuid: '6910e0df-388d-42bf-acdc-ef9afec95ef0',
      filename: 'patients/6910e0df-388d-42bf-acdc-ef9afec95ef0.ply',
      fileSize: 2559284,
      fileType: 'ply',
      subGroup: '',
    },
    frontSmileScanFile: {
      fileGuid: '5ae753be-d4b4-4e49-992e-cdc913389694',
      filename: 'patients/5ae753be-d4b4-4e49-992e-cdc913389694.jpg',
      fileSize: 66396,
      fileType: 'jpg',
      subGroup: '',
    },
  },
  sampleOrderDesignSimulation,
};
